export default __webpack_public_path__ + "static/media/3199.b2494883.png";